// extracted by mini-css-extract-plugin
export var SideMenuContainer = "SideMenu-module--SideMenuContainer--caumP";
export var Selected = "SideMenu-module--Selected--3kr4v";